import React, { useState } from 'react';
import { getModule } from '@jwp/ott-common/src/modules/container';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';
import Button from '@jwp/ott-ui-react/src/components/Button/Button';

import styles from './LoginForm.module.scss';

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const accountController = getModule(AccountController);

    accountController.login(email, password, '').catch((error) => {
      setError(error.message || 'An unknown error occurred');
    });
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      {error && <div className={styles.error}>{error}</div>}
      <input
        type="text"
        placeholder="Email address or username"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        autoCapitalize="off"
        className={styles.input}
      />
      <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required className={styles.input} />
      <Button type="submit" label="Sign In" color="primary" variant="contained" fullWidth className={styles.button} />
    </form>
  );
};

export default LoginForm;
